import { AddressProps, PropertyCommonsProps } from "@/custom-types";
import { CreatePropertyInput, CreateUnityInput, PropertyTypeOption } from "@/graphql/generated";

type ActionsTypes =
  { type: 'CREATE_PROPERTY-set-type'; payload: PropertyTypeOption }
  | { type: 'CREATE_PROPERTY-set_address'; payload: AddressProps }
  | { type: 'CREATE_PROPERTY-set_ownership'; payload: string }
  | { type: 'CREATE_PROPERTY-set_name'; payload: string }
  | { type: 'CREATE_PROPERTY-set_unities'; payload: CreateUnityInput[] }
  | { type: 'CREATE_PROPERTY-set_commons'; payload: PropertyCommonsProps }

export const CreatePropertyReducer = (state: CreatePropertyInput, action: ActionsTypes): CreatePropertyInput => {
  switch (action.type) {
    case 'CREATE_PROPERTY-set-type':
      return {
        ...state,
        propertyType: action.payload,
      }

    case 'CREATE_PROPERTY-set_address': {
      const {
        city,
        country,
        state: addressState,
        ...address
      } = action.payload

      return {
        ...state,
        ...address,
        cityId: city,
        stateId: addressState,
        countryId: country,
      }
    }
    case 'CREATE_PROPERTY-set_ownership':
      return {
        ...state,
        ownerId: action.payload,
      }

    case 'CREATE_PROPERTY-set_name':
      return {
        ...state,
        name: action.payload,
      }

    case 'CREATE_PROPERTY-set_unities':
      return {
        ...state,
        unities: action.payload,
      }

    case 'CREATE_PROPERTY-set_commons':
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}